import React, { PureComponent } from "react";
import "./LoginPage.css";
import axios from "axios";
import { endpointURL } from "../../values";
import Cookies from "js-cookie";

axios.defaults.withCredentials = true;

class LoginPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { password: "", email: "", loginError: false };
  }

  Login = (email, password) => {
    let parent = this;
    axios
      .post(endpointURL + "/login", {
        email: email,
        password: password,
      })
      .then(function (res) {
        // console.log(JSON.stringify(res.data));
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.token;
        Cookies.set("token", res.data.token);
        Cookies.set("customer_id", res.data.customer_id);
        Cookies.set("customer_name", res.data.company_name);
        Cookies.set("customer_address", res.data.customer_address);
        Cookies.set("customer_email", res.data.customer_email);
        parent.props.history.push({
          pathname: "/my-account",
          search: "",
          state: res.data, //
        });
      })
      .catch(function (error) {
        parent.failedLogin();
      });
  };

  failedLogin = () => {
    this.setState({ loginError: true });
  };

  setPassword = (event) => {
    this.setState({ password: event.target.value });
  };
  setEmail = (event) => {
    this.setState({ email: event.target.value });
  };

  EmailJoe = () => {
    window.open(
      "mailto:joe@safeplant.ie?subject=CertHub%20Account%20Password%20Request&body=Hi%20Joe%2C%0D%0ACould%20you%20please%20provide%20me%20with%20my%20CertHub%20login%20details%3F%0D%0ARegards%2C",
      "_blank"
    );
  };

  render() {
    return (
      <div className="login__main">
        <div className="login__box">
          <div className="login__title">Account Login</div>
          <div className="login__input">
            <div className="login__input-lable">Email Address:</div>
            <input
              type="text"
              className="login__input-box"
              onChange={this.setEmail}
              value={this.state.email}
            />
          </div>
          <div className="login__input">
            <div className="login__input-lable">Password</div>
            <input
              type="password"
              className="login__input-box"
              onChange={(event) => this.setPassword(event)}
              value={this.state.password}
            />
          </div>
          {this.state.loginError && (
            <div className="login__failed">
              Email or password are incorrect, please try again!
            </div>
          )}
          <div
            className="login__button"
            onClick={() => this.Login(this.state.email, this.state.password)}
          >
            Login
          </div>
          <div className="login__msg">
            Forgotten your login details? Please contact:{" "}
            <span className="login__msg-email" onClick={() => this.EmailJoe()}>
              joe@safeplant.ie
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPage;
